export default {
    accountsList: [],
    numberOfResults: 1
}